module.exports = __webpack_public_path__ + "static/pdf2-d2b7570cd5d58e4c0735aa2ac6155efc.png";